import TermAgeTable from "./TermAgeTable";

export default TermAgeTable;